import { playerControlsZIndex } from '../../elements/CustomResetPlayer'

export const postResetOverlayZIndex = playerControlsZIndex + 1
